/**
 * Karbon360° — legacy page navbar (now inert).
 *
 * PHASE 1 of the v2 redesign moved the top bar into the shell (see Shell.js →
 * v2/TopbarV2.jsx), which provides the breadcrumb trail, ⌘K launcher,
 * reporting-period switcher and account menu.
 *
 * Most pages render `<Navbar pageTitle="…" />` as their first child. Rather than
 * editing 13 files to delete those lines — pages that Phase 3 rewrites anyway —
 * this component now renders nothing. Keeping it avoids duplicate chrome while
 * leaving every call site valid.
 *
 * `pageTitle` is still accepted so no call site breaks. The breadcrumb trail is
 * derived from the route instead, in v2/nav-model.js → CRUMBS.
 *
 * The previous implementation (page title, message/bell decorations, user
 * dropdown with plan badge and admin links) is preserved in git history at tag
 * `v1.0-pre-redesign`. Everything it did that was functional — account details,
 * plan badge, admin links, logout — now lives in TopbarV2.
 */
import React from 'react';

// eslint-disable-next-line no-unused-vars
const Navbar = ({ pageTitle = 'Dashboard' }) => null;

export default Navbar;
